import { render, staticRenderFns } from "./IconPhotographOutline.vue?vue&type=template&id=bb3b9306"
import script from "./IconPhotographOutline.vue?vue&type=script&lang=js"
export * from "./IconPhotographOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports